<template>
  <div class="flex h-screen items-center justify-center">
    <transition name="fade" mode="out-in">
      <div v-if="loading" class="flex h-full w-full items-center justify-center" key="1">
        <div class="animate-spin">
          <i v-html="$icons.spinner_lg"></i>
          <span class="sr-only">Carregando</span>
        </div>
      </div>
      <success-component v-else-if="success" key="2" :transactionData="transactionData" />
      <error-component v-else key="3" />
    </transition>
  </div>
</template>

<script>
import successComponent from "../components/confirmation/success.component.vue";
import axios from "axios";
import { v4 } from "uuid";
import { Encrypt } from "../../../shared/utils/encrypt";
import ErrorComponent from "../components/confirmation/error.component.vue";

export default {
  components: { successComponent, ErrorComponent },

  data() {
    return {
      success: false,
      loading: true,
      transactionData: null,
    };
  },

  methods: {
    confirmPayment() {
      return new Promise((resolve, reject) => {
        let uuidv4 = v4();

        let uuidKey = "".padStart(32, uuidv4.slice(0, 4));

        let payload = {
          uuidv4,
          confirm_uuid: this.$route.query.return_uuid,
        };

        let body = {
          uuidv4,
          p: Encrypt(JSON.stringify(payload), uuidKey),
        };

        let config = {
          headers: {
            authorization: uuidv4,
          },
          params: {
            hash: Encrypt(uuidv4, uuidKey),
          },
        };

        axios
          .post(this.$endpoint.CONFIRM_PAYMENT, body, config)
          .then((res) => {
            // console.log(res);
            resolve(res.data);
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      });
    },

    async setConfirmationStatus() {
      try {
        const data = await this.confirmPayment();
        this.transactionData = data;
        this.success = true;
      } catch (err) {
        console.error(err);
        this.success = false;
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    setTimeout(() => {
      this.setConfirmationStatus();
    }, 10000);
  },
};
</script>

<style lang="scss">
.fade {
  &-enter,
  &-leave-to {
    @apply scale-125 opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-500 ease-in-out;
  }
  // &-enter-to,
  // &-leave {
  //   @apply scale-125 opacity-0;
  // }
}
</style>
